export class IntegrationCredentials {
  accountName: string = '';
  environment: string = '';
  password: string = '';
  username: string = '';
}
